import { PhotoIcon } from '@heroicons/react/24/solid';

/**
 * Get icon component for different file types
 * @param {string} type - File type
 * @param {Object} file - File object
 * @param {string} theme - Theme ('light' or 'dark')
 * @returns {JSX.Element} Icon component
 */
export const getIconFile = (type, file, theme = 'light') => {
  if (type === 'image') {
    return (
      <div className="w-16 flex items-center justify-center">
        {file.thumbnail ? (
          <img
            src={file.thumbnail}
            className="w-10 h-10 object-contain"
            alt={file.name}
          />
        ) : (
          <PhotoIcon className="text-raisin-black w-7 h-7" />
        )}
      </div>
    );
  }
  return <div className="w-16 h-7 flex items-center justify-center">N</div>;
};

/**
 * Format file size label
 * @param {string} type - File type
 * @param {number} size - File size in bytes
 * @returns {string} Formatted size label
 */
export const getLabel = (type, size) => {
  if (type === 'image' && size > 0) {
    const value = Math.round((size / (1024 * 1024)) * 100) / 100;
    return value + ' MB';
  }
  return '-';
};
